import { Button, Dropdown } from '@dnb/eufemia';
import { email as MailIcon, launch as LaunchIcon } from '@dnb/eufemia/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import { ApiDetailedResponse } from '@/openapi/schema';
import { DoNavigateProps } from '@/pages/api-documentation/ApiDocumentation';

import type { DropdownOption } from '../constants/types';

import {
  StyledButtonWrapper,
  StyledEnvironment,
  StyledHeaderControls as StyledHeaderControls,
} from '../styles/Api.styles';

export interface HeaderType {
  environments?: DropdownOption[];
  releases?: DropdownOption[];
  selectedVersion: string | null;
  selectedEnvironment: string | null;
  doNavigate: (props: DoNavigateProps) => void;
  selected?: string | null;
  canSubscribe: boolean;
  activeApi?: ApiDetailedResponse | undefined;
}

const HeaderControls = ({
  environments,
  selectedEnvironment,
  releases,
  selectedVersion,
  doNavigate,
  selected,
  canSubscribe,
  activeApi,
}: HeaderType) => {
  const navigate = useNavigate();

  return (
    <StyledHeaderControls>
      <StyledEnvironment>
        {environments && environments.length > 0 && (
          <Dropdown
            data={environments}
            label="Environment"
            label_direction="vertical"
            on_change={({ data }) => {
              doNavigate({ env: data.key });
            }}
            title="Select environment"
            value={environments.findIndex((option) => option.key === selectedEnvironment)}
          />
        )}

        {environments && environments.length > 0 && releases && releases.length > 0 && (
          <Dropdown
            data={releases}
            label="Version"
            label_direction="vertical"
            on_change={({ data }) => {
              doNavigate({ release: data.key });
            }}
            title="Select version"
            value={releases.findIndex((option) => option.key === selectedVersion)}
          />
        )}
      </StyledEnvironment>
      <StyledButtonWrapper>
        {canSubscribe && (
          <Button
            icon={MailIcon}
            icon_position="left"
            on_click={() => navigate(`/subscriptions/releases/${selected}`)}
            variant="secondary"
          >
            Subscribe
          </Button>
        )}
        {activeApi?.isOwner && activeApi?.ownerTeamId && (
          <Button
            element={RouterLink}
            icon={<LaunchIcon />}
            target="_blank"
            to={`/team/${activeApi.ownerTeamId}/application/${activeApi.appId}/api/${activeApi.id}`}
            tooltip="Manage visibility, access and more."
            variant="secondary"
          >
            Manage API
          </Button>
        )}
      </StyledButtonWrapper>
    </StyledHeaderControls>
  );
};

export default HeaderControls;
